// extracted by mini-css-extract-plugin
module.exports = {"movieCard":"MovieTheaterSkeltonCard_movieCard__9HcSm","skeltonImage":"MovieTheaterSkeltonCard_skeltonImage__0SNyj"};